<template>
  <mdb-modal
    size="lg"
    v-model="modal"
    centered >
    <mdb-modal-header>
      <div>
        <div class="h5">『{{ review.client_project.marketer?.family_name }} {{ review.client_project.marketer?.first_name }}』の評価</div>
      </div>
    </mdb-modal-header>
    <mdb-modal-body>
      <mdb-row class="m-3">
        <mdb-col col="4">
          <strong>クライアント</strong>
        </mdb-col>
        <mdb-col>{{ review.client_project.client?.name }}</mdb-col>
      </mdb-row>
      <mdb-row class="m-3">
        <mdb-col col="4">
          <strong>契約業務</strong>
        </mdb-col>
        <mdb-col>
          {{ review.client_project.title }}
          <div v-if="review.client_project.project_tags.length > 0" class="d-flex flex-wrap">
            <span class="m-1" v-for="tag in review.client_project.project_tags" :key="tag.id">#{{ tag.tag }} </span>
          </div>
          ({{ review.client_project.start_date }} ～ {{ review.client_project.end_date }})
        </mdb-col>
        <mdb-col col="auto" class="float-right">
          <mdb-tooltip v-if="staff.role == 'admin'" v-model="editTip">
            <template #reference>
              <mdb-btn color="primary" @click="projectEdit" floating><mdb-icon icon="pen" /></mdb-btn>
            </template>
            <template #tip>案件編集</template>
          </mdb-tooltip>
        </mdb-col>
      </mdb-row>
      <hr />
      <mdb-row class="m-3">
        <mdb-col col="2"></mdb-col>
        <mdb-col col="2">
          <strong>評価</strong>
        </mdb-col>
        <mdb-col>
          <strong>コメント</strong>
        </mdb-col>
      </mdb-row>
      <mdb-row class="m-3">
        <mdb-col col="2">
          <strong>総合</strong>
        </mdb-col>
        <mdb-col col="2">{{ review.total }}</mdb-col>
        <mdb-col v-html="sanitize(review.total_comment)"></mdb-col>
      </mdb-row>
      <mdb-row class="m-3">
        <mdb-col col="2">
          <strong>スキル</strong>
        </mdb-col>
        <mdb-col col="2">{{ review.skill }}</mdb-col>
        <mdb-col v-html="sanitize(review.skill_comment)"></mdb-col>
      </mdb-row>
      <mdb-row class="m-3">
        <mdb-col col="2">
          <strong>人柄</strong>
        </mdb-col>
        <mdb-col col="2">{{ review.personal }}</mdb-col>
        <mdb-col v-html="sanitize(review.personal_comment)"></mdb-col>
      </mdb-row>
      <mdb-row class="mt-3">
        <mdb-col col="7"></mdb-col>
        <mdb-col>
          <small>
            回答：{{ review.answer_name }}
            （{{ review.answered_at }}）
          </small>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col col="7"></mdb-col>
        <mdb-col>
          <small>
            登録：{{ review.staff?.family_name }} {{ review.staff?.first_name }}
            （{{ dateFormat(review.created_at, "YYYY/MM/DD") }}）
          </small>
        </mdb-col>
      </mdb-row>
    </mdb-modal-body>
    <mdb-modal-footer v-if="staff.role == 'admin'">
      <mdb-btn color="primary" class="m-2" @click="edit">編集</mdb-btn>
      <mdb-btn color="light" class="m-2" @click="modal = false">キャンセル</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<style scoped>
.modal-content {
  max-height: 656px
}
.modal-body {
  max-height: 624px
}
.tools span {
  display: inline-block;
  text-align: center;
  padding: 10px 30px;
  border: solid 1px #29b28d;
  margin-top: 20px;
  cursor: pointer;
}
.cancel {
  color: #29b28d;
  margin-right: 20px;
}
.save {
  background-color:#29b28d;
  color: #fff;
}

.date-inline .form-outline {
  display: inline-block;
}

.icon-btn {
  color: #1266f1;
}
</style>

<script>
import { computed, ref } from "vue";
import { useStaff } from "@/common/staff";

export default {
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    review: {
      type: Object,
      required: true
    }
  },
  emits: ["edit", "project-edit", "update:modelValue"],
  setup(props, { emit }) {
    const modal = computed({
      get: () => props.modelValue,
      set: (val) => { emit("update:modelValue", val) }
    });

    const { staff } = useStaff(true);

    const editTip = ref(false);

    const edit = () => {
      emit("edit");
      modal.value = false;
    };

    const projectEdit = () => {
      emit("project-edit");
      modal.value = false;
    }

    return { modal, staff, editTip, edit, projectEdit };
  },
}
</script>